import React, { Component } from "react";
import {
  DataGrid,
  FilterRow,
  Editing,
  Column,
  Paging,
  Pager,
  FormItem,
  StateStoring,
} from "devextreme-react/data-grid";
import uiInfo from "../../ui-info";
import PaginaToolbar from "../../components/PaginaToolbar";
import {
  criarResponsavelTecnicoDs
} from "../../DataSources";

const localStorageKey = "cadastroResponsavelTecnicoGridState";

export default class ResponsavelTecnicoBox extends Component {
  constructor() {
    super();
    this._gridInstance = React.createRef();
    this.onAtualizandoRow = this.onAtualizandoRow.bind(this);
  }

  onAtualizandoRow(e) {
    e.cancel = true;
    this.props.history.push("responsaveistecnicos/editar/" + e.data.id);
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <PaginaToolbar
            titulo="Responsáveis Técnicos"
            novoCb={this.novoRegistro.bind(this)}
          >
            <DataGrid
              ref={(grid) => (this._gridInstance = grid)}
              dataSource={criarResponsavelTecnicoDs()}
              showBorders={true}
              rowAlternationEnabled={true}
              remoteOperations={true}
              columnAutoWidth={true}
              columnHidingEnabled={true}
              focusedRowEnabled={true}
              wordWrapEnabled={window.innerWidth < 800}
              filterSyncEnabled={true}
              onEditingStart={this.onAtualizandoRow}
            >
              <StateStoring
                enabled={true}
                type={"localStorage"}
                storageKey={localStorageKey}
              />
              <FilterRow visible={true} />
              <Editing allowDeleting={true} allowUpdating={true} mode />
              <Column
                dataField={"id"}
                caption={"#"}
                allowEditing={false}
                width={80}
                alignment={"center"}
              />
              <Column
                dataField={"prefeituraId"}
                caption={"Prefeitura"}
                visible={false}
              >
                <FormItem visible={false}></FormItem>
              </Column>
              <Column dataField={"nome"} caption={"Nome"} />
              <Column dataField={"cpf"} caption={"CPF"} />
              <Column dataField={"cnpj"} caption={"CNPJ"} />
              <Column dataField={"crea"} caption={"CREA"} />
              <Column dataField={"rg"} caption={"RG"} />
              <Column dataField={"cep"} caption={"CEP"} />
              <Column dataField={"ruaEndereco"} caption={"Rua"} />
              <Column dataField={"numeroEndereco"} caption={"Número"} />
              <Column dataField={"complemento"} caption={"Complemento"} />
              <Column dataField={"bairro"} caption={"Bairro"} />
              <Column dataField={"cidade"} caption={"Cidade"} />
              <Column dataField={"uf"} caption={"UF"} />
              <Column dataField={"telefone"} caption={"Telefone"} />

              <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
              <Pager
                showPageSizeSelector={true}
                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
              />
            </DataGrid>
          </PaginaToolbar>
        </div>
      </React.Fragment>
    );
  }

  novoRegistro() {
    let gridState = this._gridInstance.instance.state();
    localStorage.setItem(localStorageKey, JSON.stringify(gridState));
    this.props.history.push("responsaveistecnicos/novo");
  }
}
